import React, { useState, useEffect, useMemo, useCallback } from "react"

import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { Icon, Button, Grid } from "@mui/material"
import { useTreasureHunt } from "components/useTreasureHunt/useTreasureHunt"

// Components
import TeacherManagementInformationSection from "components/TeacherManagementInformationSection/TeacherManagementInformationSection"
import TeacherManagementLeaveSection from "components/TeacherManagementLeaveSection/TeacherManagementLeaveSection"
import TeacherManagementTimeSheetSection from "components/TeacherManagementTimeSheetSection/TeacherManagementTimeSheetSection"
import TeacherManagementPerformanceSection from "components/TeacherManagementPerformanceSection/TeacherManagementPerformanceSection"
import TeacherManagementChangeSection from "components/TeacherManagementChangeSection/TeacherManagementChangeSection"
import TeacherManagementCalendarSection from "components/TeacherManagementCalendarSection/TeacherManagementCalendarSection"

// Icons
import AssistantMail from "components/icons/AssistantMail"
import AssistantBox from "components/icons/AssistantBox"
import MenuCalendarIcon from "components/icons/MenuCalendarIcon"
// Router
import { useNavigate, useParams } from "react-router-dom"

const tabs = [
  {
    icon: () => <AssistantBox />,
    title: "Visa WP",
    link: "information",
    component: <TeacherManagementInformationSection />,
  },
  {
    icon: () => <AssistantMail />,
    title: "Leave",
    link: "leave",
    component: <TeacherManagementLeaveSection />,
  },
  {
    icon: () => <AssistantMail />,
    title: "Timesheet",
    link: "timesheet",
    component: <TeacherManagementTimeSheetSection />,
  },
  // {
  //   icon: () => <AssistantMail />,
  //   title: "Teacher Performance",
  //   link: "performance",
  //   component: <TeacherManagementPerformanceSection />,
  // },
  {
    icon: () => <AssistantMail />,
    title: "Teacher change",
    link: "change",
    component: <TeacherManagementChangeSection />,
  },
  // {
  //   icon: () => (
  //     <MenuCalendarIcon width="13" height="13" stroke="rgb(23, 43, 77)" />
  //   ),
  //   title: "Teacher calendar",
  //   link: "calendar",
  //   component: <TeacherManagementCalendarSection />,
  //   // component: <div>Not Found</div>,
  // },
]

function TeacherManagement() {
  const { tab, subTab } = useParams()
  const navigate = useNavigate()
  const [tabIndex, setTabIndex] = useState(0)
  const { triggerIfNew } = useTreasureHunt("teacher-management-tab")

  const handleChange = useCallback(
    (index) => {
      setTabIndex(index)
      navigate(`/assistant/teacher-management/${tabs[index].link}`)
    },
    [navigate]
  )

  const renderComponent = useMemo(() => {
    return tabs[tabIndex]?.component || <div>Not Found</div>
  }, [tabIndex])

  useEffect(() => {
    const index = tabs.findIndex((item) => item.link === subTab)
    if (!subTab || index === -1) {
      if (tabIndex !== 0) {
        setTabIndex(0)
        navigate(`/assistant/teacher-management/${tabs[0].link}`)
      }
    } else if (index !== tabIndex) {
      setTabIndex(index)
    }
  }, [subTab, navigate])

  return (
    <MDBox mb={3} className={`teacher-management`}>
      <MDBox className={`teacher-management__header-box`}>
        <Grid
          container
          className={`teacher-management__tab-wrapper`}
          alignItems="center"
        >
          {tabs.map((item, index) => {
            return (
              <Button
                key={index}
                className={`${`teacher-management__tab-item`} ${
                  tabIndex === index ? "active" : ""
                }`}
                onClick={() => {
                  triggerIfNew()
                  handleChange(index)
                }}
              >
                <Icon component={item.icon} />
                <MDTypography variant="body2">{item.title}</MDTypography>
              </Button>
            )
          })}
        </Grid>
      </MDBox>
      {tabIndex > -1 && renderComponent}
    </MDBox>
  )
}

export default TeacherManagement
